import { render, staticRenderFns } from "./initialForm.vue?vue&type=template&id=48edd0b2&scoped=true&"
import script from "./initialForm.vue?vue&type=script&lang=ts&"
export * from "./initialForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48edd0b2",
  null
  
)

export default component.exports